/**
 * FAQ par rubriques — menu de rubriques + panneaux de questions.
 *
 * Desktop : le menu reste affiché, cliquer une rubrique change le panneau.
 * Mobile  : le panneau remplace le menu, le retour ramène à la liste.
 * Les transitions sont portées par base.css (.is-panel-open, .is-entering).
 */

const MOBILE_QUERY = '(max-width: 749px)';

class FaqCategories extends HTMLElement {
  /** @type {HTMLElement[]} */
  #links = [];
  /** @type {HTMLElement[]} */
  #panels = [];

  connectedCallback() {
    this.#links = [...this.querySelectorAll('[data-faq-cat]')];
    this.#panels = [...this.querySelectorAll('[data-faq-panel]')];
    if (!this.#links.length) return;

    this.#links.forEach((link) => {
      link.addEventListener('click', () => this.#open(link.dataset.faqCat));
    });

    this.querySelectorAll('[data-faq-back]').forEach((btn) => {
      btn.addEventListener('click', () => this.#back());
    });
  }

  get #isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  #open(id) {
    if (!id) return;

    this.#links.forEach((link) => {
      link.setAttribute('aria-current', String(link.dataset.faqCat === id));
    });

    this.#panels.forEach((panel) => {
      const isActive = panel.dataset.faqPanel === id;
      panel.hidden = !isActive;
      panel.classList.remove('is-entering');

      if (isActive) {
        // Relance l'animation même si le panneau était déjà celui affiché.
        void panel.offsetWidth;
        panel.classList.add('is-entering');
      }
    });

    if (this.#isMobile) {
      this.classList.add('is-panel-open');
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  #back() {
    this.classList.remove('is-panel-open');
    this.classList.remove('is-menu-returning');
    void this.offsetWidth;
    this.classList.add('is-menu-returning');
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('faq-categories')) {
  customElements.define('faq-categories', FaqCategories);
}
